export default __webpack_public_path__ + "static/media/completed-request.e7dab0b4.svg";